import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@polichat/flamboyant';
import { useGlotaT } from '../../../../../hooks/useGlotaTranslation';

import styles from './style.module.css';
import { IconPlusIcon } from '../../../../../assets/illustratorElement/iconPlusIcon/iconPlusIcon';
import Animation from 'src/components/common/animation';

interface ZapiModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default function LeadsModal({
  isOpen,
  isLoading,
  onClose,
  onSubmit,
}: ZapiModalProps): JSX.Element {
  // Traduções
  const metaTitle = useGlotaT('spa.integrations.meta.title');
  const disconnectTitle = useGlotaT('spa.integrations.meta.disconnectTitle');
  const cancel = useGlotaT('spa.integrations.meta.cancel');
  const continueLabel = useGlotaT('spa.integrations.meta.continue');
  
  return (
    <>
      <Modal isOpen={isOpen} toggle={onClose}>
        <ModalHeader>
          <div className={styles.image_header}>
            <IconPlusIcon
              firstIcon="onlyLogo"
              secondIcon="metaIcon"
              secondColor="var(--success)"
            />
            {metaTitle}
          </div>
        </ModalHeader>
        <ModalBody className={styles.modal_body}>
          {disconnectTitle}
        </ModalBody>
        <ModalFooter>
          <div className={styles.buttons_container}>
            <Button
              style={{
                minWidth: '100px',
                minHeight: '40px',
              }}
              disabled={isLoading}
              gradient="danger"
              className={styles.custom_button}
              onClick={onClose}
            >
              {cancel}
            </Button>
            <Button
              style={{
                minWidth: '100px',
                minHeight: '40px',
              }}
              disabled={isLoading}
              className={styles.custom_button}
              onClick={onSubmit}
            >
              {isLoading ? (
                <Animation
                  icon="loading"
                  style={{
                    borderColor: 'var(--menus-background-sidebar-color)',
                  }}
                  size="minorLittleTiny"
                  color="var(--white)"
                />
              ) : (
                continueLabel
              )}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
}
